import React from 'react';
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ExportButtons = ({ jsonData, sheetData, csvData, txtAttributes, pdfAttributes}) => {

const handleDownloadExcel = () => {
    const wb = XLSX.utils.book_new();

    const data = sheetData();
    let combinedData = [];
    
    for (const item in data) {
      combinedData.push(...data[item]);
      combinedData.push([]);
    }

    const ws = XLSX.utils.aoa_to_sheet(combinedData);

    XLSX.utils.book_append_sheet(wb, ws, "Relatório");

    XLSX.writeFile(wb, 'relatorio.xlsx');
};

const handleDownloadCSV = () => {
  const data = csvData();
  const ws = XLSX.utils.aoa_to_sheet(data);
  let csvContent = XLSX.utils.sheet_to_csv(ws, {FS: ";"});
  const BOM = '\uFEFF';
  csvContent = BOM + csvContent;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  downloadArchive(blob, '.csv')
};

const handleDownloadJSON = () => {
  const data = jsonData();
  const jsonString = JSON.stringify(data, null, 2);
  downloadArchive(jsonString, '.json');
};

const handleDownloadTXT = () => {
  let txtContent = '';
  for (const table in txtAttributes) {    
    const tableTxt = document.getElementById(table);
    const colSizes = txtAttributes[table].colSizes;
  
    function padString(str, length) {
        return str.padEnd(length, ' ');
    }

    for (let row of tableTxt.rows) {
        let rowData = [];
        let countCell = 0;
        for (let cell of row.cells) {
            rowData.push(padString(cell.innerText, colSizes.length === 1 ? colSizes[0] : colSizes[countCell]));
            countCell++;
        }
        txtContent += rowData.join(' ') + '\n';
    }

    txtContent += '\n\n';
  }
  downloadArchive(txtContent, '.txt');
};

function downloadArchive(content, extension){
  const blob = new Blob([content], { type: "application/json;charset=utf-8;" });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `relatorio${extension}`);

  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function exportTablesToPDF() {
  const optionsPdf = !!pdfAttributes.optionsPdf ? pdfAttributes.optionsPdf : {format: 'a4', orientation: 'portrait'};
  const styles = !!pdfAttributes.styles ? pdfAttributes.styles : {}; 
  const doc = new jsPDF(optionsPdf);
  let tableY = 10;
  for (const table of pdfAttributes.ids) {
    const tableToPdf = document.getElementById(table);
    
    if(!tableToPdf){
      continue
    }
    
    let tablesStyles = !!styles[table] ? styles[table] : {};
  
    doc.autoTable({
        html: tableToPdf,
        startY: tableY,
        ...tablesStyles,
        rowPageBreak: 'avoid',
        willDrawCell: function (data) {
            if (data.row.index === data.table.body.length - 1) {
                const afterRowPosY = doc.autoTable.previous.finalY || 0;
                const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
                
                if (afterRowPosY + data.row.height > pageHeight) {
                    doc.addPage();
                    data.cell.x = 0;
                }
            }
        }
    });

    tableY = doc.lastAutoTable.finalY + 20
  }

  doc.save('relatorio.pdf');
}

  return (
    <div className='mb-2'>
        {jsonData && <button className='btn btn-primary mr-2' onClick={handleDownloadJSON}>JSON</button>}
        {sheetData && <button className='btn btn-primary mr-2' onClick={handleDownloadExcel}>XLSX</button>}
        {csvData && <button className='btn btn-primary mr-2' onClick={handleDownloadCSV}>CSV</button>}
        {txtAttributes && <button className='btn btn-primary mr-2' onClick={handleDownloadTXT}>TXT</button>}
        {pdfAttributes && <button className='btn btn-primary' onClick={exportTablesToPDF}>PDF</button>}
    </div>
  );
};

export default ExportButtons;
